import { colord, extend } from 'colord';
import mixPlugin from 'colord/plugins/mix';

extend([mixPlugin]);

export function generatePalette(baseColor: string): Record<number, string> {
  const base = colord(baseColor);
  return {
    50:  colord('#ffffff').mix(base, 0.05).toHex(),
    100: colord('#ffffff').mix(base, 0.1).toHex(),
    150: colord('#ffffff').mix(base, 0.15).toHex(),
    200: colord('#ffffff').mix(base, 0.25).toHex(),
    250: colord('#ffffff').mix(base, 0.35).toHex(),
    300: colord('#ffffff').mix(base, 0.45).toHex(),
    400: colord('#ffffff').mix(base, 0.6).toHex(),
    500: base.toHex(),
    600: base.mix('#000000', 0.1).toHex(),
    700: base.mix('#000000', 0.2).toHex(),
    800: base.mix('#000000', 0.3).toHex(),
    900: base.mix('#000000', 0.4).toHex(),
    950: base.mix('#000000', 0.5).toHex(),
  };
}
